import React from "react";

export const Page7Tamil = () => {
  return (
    <div className="page-tamil-container">
      <p>
        நம் பணமானாலும் பரவாயில்லை என்று செலவழிக்கலாம் நம்மை நம்பி மற்றவர்
        கொடுக்கும் பணம் கண்ணும் கருத்துமாக செலவழிக்கப்பட வேண்டுமே என்ற எண்ணம்
        தோன்றியது - இருந்தாலும் கிராமவாசிகளின் நீண்ட நாள் விருப்பத்தை
        நிறைவேற்றப் போகிறோம் என்ற எண்ணத்தோடும் மகிழ்ச்சியோடும் திரு எஸ்.துரைராஜ்
        அவர்களுக்கு ஒத்துழைப்பு தந்து எனக்கிட்ட பணியை சிறப்பாக முடித்துள்ளேன்
        என்று எண்ணுகிறேன். நான் புகழுக்காகவோ, பெருமைக்காகவோ, சுயநலத்திற் காகவோ
        அல்லது பெயருக்காகவோ இப்பணியை ஏற்கவில்லை. மக்கள் விரும்புகிறார்கள்,
        ஆதியண்ணனும், அய்யனாரும் கட்டளை இடுகிறார்கள், துரைராஜ் அன்புக்கரம்
        நீட்டுகிறார் என்ற முறையிலேயே பொறுப்பை ஏற்றுக் கொண்டேன்.
      </p>
      <p>
        எனக்கு உறுதுணையாக இருந்து குறித்த காலத்தில் பணியை சிறப்பாக செய்து
        முடித்து புதிய சிலையை அமைத்த ஸ்தபதியார் திரு. R. சௌந்தராஜன்
        கண்ணைக்கவரும் வண்ணம் தீட்டித் தந்த திரு. தியாகு அவர்களையும் மற்றும்
        பல்வேறான உதவிகளும், ஒத்துழைப்பும் புரிந்த அனைவருக்கும் என் நன்றி!
      </p>
      <p >
        கோயில் அமைப்பு, சிலை அமைப்பு யாகசாலை அமைப்பு கும்பாபிஷேக நிகழ்ச்சிகள்
        அனைத்தையும் ஆகம் விதிகளை அறிந்த நமது அன்புக்கு பாத்திரமான திரு. வீரமணி
        சிவாச்சாரியார் அய்யா அவர்களின் ஆலோசனைப்படியும், அவருடைய மேற்பார்வையுடன்
        அனைத்தும் முறையோடு செய்யப்பட்டது. அய்யா அவர்களுக்கும் என்னுடைய நன்றியை
        தெரிவித்துக் கொள்கிறேன்.அன்புடன்,<strong> G.ரமேஷ்</strong>
      </p>
      <p>
        ஸ்ரீ பூர்ணம்யா புஷ்பலாம்பிகா சமேத அய்யனார் ஆலய முகப்பு சிலைகள் அருள்மிகு
        ஆதியண்ணன் சிலை இவைகளை உருவாக்கிய ஸ்தபதியார் R. சௌந்தரராஜன் கூறுகிறார்.
      </p>
      <p>
        நான் இதுவரை பல கோயில்களில் சிலை அமைத்துள்ளேன். ஆனால் இந்த கோயிலில்
        அமைத்துள்ள சிலைகள் என் சக்திக்கும் அப்பாற்பட்ட தெய்வச் சிலைகளாக
        அமைந்துள்ளது.
      </p>
      <p>
        ஒரு நாள் நண்பர் ரமேஷ் அவர்கள் ஆதியண்ணன் ஆலயம் திருப்பணி செய்ய பெங்களூர்
        பக்தர் திரு. துரைராஜ் குடும்பத்தினர்கள் விரும்புகிறார்கள் நீங்கள் அந்த
        பணியை செய்து தாருங்கள் என கோயிலுக்கு அழைத்துச் சென்றார். அப்போது
        துரைராஜ் அவர்களை சந்தித்தேன் எண்ணென்ன வேலைகள் திருப்பணிக்கு
        செய்யவேண்டும் என்று திட்டமிட்டோம். ஆதியண்ணனை புதிய சிலை அமைக்க வேண்டும்
        என்று அவர்கள் விரும்பினார்கள். வழக்கப்படி நான் பூக்கட்டிப் போட்டு
        பார்த்து புதிய சிலை அமைக்கலாம் என்ற உத்தரவு கிடைத்த பிறகு பேச்சைத்
        தொடங்கினேன். சிலை எப்படி இருக்க வேண்டும் என்று அவர்களைக் கேட்டேன். உயரம்
        நடுத்தரமாக ஒரு மனிதன் உயரம் இருக்க வேண்டும். சிலை கம்பீரமாக இருக்க
        வேண்டும். கண்கவர் வனப்புடன் இருக்க வேண்டும். கருணை பொழியும் கண்கள் கொண்ட
        அமைப்பு இருக்க வேண்டும் என்றார்கள்.
      </p>
      <p>
        இம்மாதிரியான சிலை அமைக்க சுமாராக ஒரு தொகையை சொன்னேன். பணம் பற்றி இப்போது
        பேச வேண்டாம். வேண்டும் பொருள்கள் வாங்கித் தருகிறோம். கேட்ட கூலியைக்
        கொடுக்கிறோம் - மேலே சொன்னவாறு சிலை அமைய வேண்டும் என்றார்கள்.
      </p>
    </div>
  );
};
